<template>
    <div>
        <v-card>
            <v-card-title>Complaints                      
                <v-spacer></v-spacer>
                <div v-if="huov_hokl.length === 0"> 
                    <v-btn class="primary ma-2" x-small v-on:click="addHokl">Add new complaint</v-btn>
                </div>
            </v-card-title>
            <span v-if="huov_hokl.length === 0">
                <div class="pl-4 pt-3 pb-4">                
                    <v-label><span :class="{'text-color-error': hasError}">{{ this.resulttext }}</span></v-label>
                </div>
            </span>
            <span v-else>
                <incident_table :data="huov_hokl" @executeFunction="executeFunction" itemtype="complaint" class="pb-2 px-2"></incident_table>
            </span>
            <viewHkrg ref="viewHkrg" :isVisible="showDetails" @updateField="updateField" @updateData="updateData" @executeFunction="executeFunction" class="pb-2"/>
        </v-card>
        <addHokl ref="addHokl" :huov_encrid="huov_encrid" @updateData="updateData"/>
        <rmHokl ref="rmHokl" :huov_encrid="huov_encrid" @updateData="updateData" @updateField="updateField"/>
        <updHokl ref="updHokl" :huov_encrid="huov_encrid" @updateData="updateData"/>        
        <addHkrg ref="addHkrg" @updateData="updateData"/>   
        <m_attm ref="m_attm" @updateData="updateData"/>
    </div>
</template>

<script>

    import incident_table from '@/components/huov/ui/tables/hokl_hosm_table.vue'
    import addHokl from "@/components/huov/hokl/addHokl.vue";
    import rmHokl from "@/components/huov/hokl/rmHokl.vue";
    import updHokl from "@/components/huov/hokl/updHokl.vue";
    import viewHkrg from "@/components/huov/hokl/viewHkrg.vue";
    import addHkrg from "@/components/huov/hokl/addHkrg.vue";
    import m_attm from "@/components/m_attm.vue";


    export default {
        mounted(){
            this.getHokl();
        },
        props: {
            huov_encrid: String,
        },        
        components: {
            incident_table,
            addHokl,
            rmHokl,
            updHokl,
            viewHkrg,
            addHkrg,
            m_attm
        },      
        data() {
            return {
                huov_hokl: [],
                resulttext: 'No complaints filed',
                hasError: false,
                showDetails: false,
                hokl_encrid: '',
            }
        },
        methods: {         
            executeFunction(data){
                this.hokl_encrid = data[1].value;
                switch(data[0].value){
                    case 'update_complaint':
                        this.$refs.updHokl.open(data[1].value, data[2].value);
                        break;
                    case 'delete_complaint':
                        this.$refs.rmHokl.open(data[1].value, data[2].value);
                        break;    
                    case 'open_complaint':     
                        this.$refs.viewHkrg.open(data[1].value, data[2].value);
                        break;
                    case 'add_complaint_event': 
                        this.$refs.addHkrg.open(data[1].value);
                        break;
                    case 'email_complaint':
                        this.sendHokl();
                        break;
                    case 'attachments_complaint':
                        this.hoklAttm(data[2].value);
                        break;                            
                }
            },               
            getHokl(){
                this.$axios
                    .post("ares/json/ares/huov/hokl/getHokl.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getHokl"
                        },
                        getHokl: {
                            huov_encrid: this.huov_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                            this.resulttext = res.data.error.message;
                            this.hasError = true;
                        } else {                   
                            this.huov_hokl = res.data.huov_hokl.hokl;         
                            this.hasError = false;
                        }
                    });   
                },               
            addHokl(){
                this.$refs.addHokl.open();
            },            
            updateField(data){
                this[data.field]=data.value;
            },
            updateData(){
                this.getHokl();
                if(this.showDetails){ // get details if they are visible
                    this.$refs.viewHkrg.getHkrg(this.hokl_encrid);
                }
                this.$emit('updateData', 'refresh'); // send refresh to parent
            },
            sendHokl(){
                let route = this.$router.resolve({ path: `/huov/hokl/sendHokl/${this.huov_encrid}:${this.hokl_encrid}`}); 
                window.open(route.href, '_blank');
            },
            hoklAttm(hokl_code){
                this.$refs.m_attm.open('hokl', hokl_code, '', '', this.hokl_encrid, 0);
            }            
        }
    }
</script>

<style scoped>
    .text-color-error{
        color: red;
    }
    .v-label{
        color: '';
    }
</style>